export enum ReportStatus {
  REVIEWED = 'Reviewed',
  NOT_REVIEWED = 'Not Reviewed',
}
